import {
  OrderGetResponseType,
  SupplierGetResponseType,
  SupplierInvoiceCreationStageType,
  SupplierRelationshipGetResponseType,
  SupplierRelationshipPaymentDueCalculateFromType,
  SupplierRelationshipPaymentTermsRequestListResponseType,
} from "@sellar-io/api-v2/types";
import { usePaymentTermsIndicator } from "./usePaymentTermsIndicator";

export const PaymentTermsIndicator = ({
  connection,
  invoiceCreationStage,
  approved = true,
  paymentTermsRequest,
  hasDefaultPriceTier,
  supplier,
  paymentType,
  isImplicitProformaEnabled,
}: {
  connection:
    | Pick<
        SupplierRelationshipGetResponseType,
        "paymentTerms" | "paymentDueCalculateFrom" | "paymentDue"
      >
    | null
    | undefined;
  invoiceCreationStage: SupplierInvoiceCreationStageType;
  paymentTermsRequest?: {
    paymentDueCalculateFrom: SupplierRelationshipPaymentDueCalculateFromType;
    paymentDue: number;
    status: SupplierRelationshipPaymentTermsRequestListResponseType[number]["status"];
  } | null;
  hasDefaultPriceTier?: boolean;
  approved?: boolean;
  supplier?:
    | Pick<SupplierGetResponseType, "hasOptedOutSellarCredit">
    | undefined;
  paymentType?: OrderGetResponseType["paymentType"];
  isImplicitProformaEnabled?: boolean;
}) => {
  const indicator = usePaymentTermsIndicator({
    connection,
    invoiceCreationStage,
    approved,
    paymentTermsRequest,
    hasDefaultPriceTier,
    supplier,
    paymentType,
  });

  if (
    isImplicitProformaEnabled &&
    !["credit", "sellarCredit"].includes(indicator.type ?? "")
  ) {
    return null;
  }

  return indicator.full;
};
